<template>
  <component
    :is="getComponentForType(component.typeCode)"
    v-for="component of components"
    :key="component.uid"
    :component-data="component"
  />
</template>
<script>
import CmsApi from '@/api/cms';
import {mapGetters} from 'vuex';

import {getComponentForType} from '@/modules/CmsComponentMapper.js';
export default {
  props: {
    componentData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      components: [],
      getComponentForType: getComponentForType,
    };
  },
  computed: {
    ...mapGetters('backend', ['occUrlParams']),
    componentNames() {
      return this.componentData?.components.split(' ');
    },
  },
  watch: {
    componentNames: {
      handler(value) {
        if (value.length) {
          this.fetchComponents();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async fetchComponents() {
      this.components = await CmsApi.getComponentsByIds(this.occUrlParams.userId, this.componentNames);
    },
  },
};
</script>
